/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal DTO for creating/updating a legal entity borrower
 * @export
 * @interface CreateOrUpdateMinimalBorrowerLegalEntityDto
 */
export interface CreateOrUpdateMinimalBorrowerLegalEntityDto {
    /**
     * ID of the legal entity (null if creation)
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerLegalEntityDto
     */
    id?: string | null;
    /**
     * Name of the company/legal entity
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerLegalEntityDto
     */
    companyName: string;
    /**
     * Email address of the legal entity
     * @type {string}
     * @memberof CreateOrUpdateMinimalBorrowerLegalEntityDto
     */
    email: string;
}

/**
 * Check if a given object implements the CreateOrUpdateMinimalBorrowerLegalEntityDto interface.
 */
export function instanceOfCreateOrUpdateMinimalBorrowerLegalEntityDto(value: object): value is CreateOrUpdateMinimalBorrowerLegalEntityDto {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function CreateOrUpdateMinimalBorrowerLegalEntityDtoFromJSON(json: any): CreateOrUpdateMinimalBorrowerLegalEntityDto {
    return CreateOrUpdateMinimalBorrowerLegalEntityDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateMinimalBorrowerLegalEntityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateMinimalBorrowerLegalEntityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['companyName'],
        'email': json['email'],
    };
}

export function CreateOrUpdateMinimalBorrowerLegalEntityDtoToJSON(json: any): CreateOrUpdateMinimalBorrowerLegalEntityDto {
    return CreateOrUpdateMinimalBorrowerLegalEntityDtoToJSONTyped(json, false);
}

export function CreateOrUpdateMinimalBorrowerLegalEntityDtoToJSONTyped(value?: CreateOrUpdateMinimalBorrowerLegalEntityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'email': value['email'],
    };
}

